import { callApi, HttpMethod } from "../../../utils/httpRequest";

export const updateTimecardTemplate = async ({
  userId,
  timeCardTemplateFileKey,
  timeCardTemplateFolderName,
}: {
  userId: string;
  timeCardTemplateFileKey: string;
  timeCardTemplateFolderName: string;
}) => {
  const res = await callApi({
    method: HttpMethod.PUT,
    url: `${global.api}/facilityprofile/${userId}/time-card-template`,
    body: {
      timeCardTemplateFileKey,
      timeCardTemplateFolderName,
    },
  });

  return res;
};

export const deleteTimecardTemplate = async ({ userId }: { userId: string }) => {
  const res = await callApi({
    method: HttpMethod.DELETE,
    url: `${global.api}/facilityprofile/${userId}/time-card-template`,
  });

  return res;
};
